module.exports = __webpack_public_path__ + "static/media/delete.9d1b0e7d.svg";